/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as EmbedNetworkIdRouteImport } from './routes/embed/$networkId'
import { Route as AppLegalRouteImport } from './routes/_app/legal'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppDataIndexRouteImport } from './routes/_app/data/index'
import { Route as AppDataVehiclesVehicleIdRouteImport } from './routes/_app/data/vehicles/$vehicleId'
import { Route as AppDataNetworksNetworkIdRouteImport } from './routes/_app/data/networks/$networkId'
import { Route as AppDataLinesLineIdVehicleAssignmentsRouteImport } from './routes/_app/data/lines/$lineId/vehicle-assignments'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const EmbedNetworkIdRoute = EmbedNetworkIdRouteImport.update({
  id: '/embed/$networkId',
  path: '/embed/$networkId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppLegalRoute = AppLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppDataIndexRoute = AppDataIndexRouteImport.update({
  id: '/data/',
  path: '/data/',
  getParentRoute: () => AppRoute,
} as any)
const AppDataVehiclesVehicleIdRoute =
  AppDataVehiclesVehicleIdRouteImport.update({
    id: '/data/vehicles/$vehicleId',
    path: '/data/vehicles/$vehicleId',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataNetworksNetworkIdRoute =
  AppDataNetworksNetworkIdRouteImport.update({
    id: '/data/networks/$networkId',
    path: '/data/networks/$networkId',
    getParentRoute: () => AppRoute,
  } as any)
const AppDataLinesLineIdVehicleAssignmentsRoute =
  AppDataLinesLineIdVehicleAssignmentsRouteImport.update({
    id: '/data/lines/$lineId/vehicle-assignments',
    path: '/data/lines/$lineId/vehicle-assignments',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/help': typeof AppHelpRoute
  '/legal': typeof AppLegalRoute
  '/embed/$networkId': typeof EmbedNetworkIdRoute
  '/data/': typeof AppDataIndexRoute
  '/data/networks/$networkId': typeof AppDataNetworksNetworkIdRoute
  '/data/vehicles/$vehicleId': typeof AppDataVehiclesVehicleIdRoute
  '/data/lines/$lineId/vehicle-assignments': typeof AppDataLinesLineIdVehicleAssignmentsRoute
}
export interface FileRoutesByTo {
  '/help': typeof AppHelpRoute
  '/legal': typeof AppLegalRoute
  '/embed/$networkId': typeof EmbedNetworkIdRoute
  '/': typeof AppIndexRoute
  '/data': typeof AppDataIndexRoute
  '/data/networks/$networkId': typeof AppDataNetworksNetworkIdRoute
  '/data/vehicles/$vehicleId': typeof AppDataVehiclesVehicleIdRoute
  '/data/lines/$lineId/vehicle-assignments': typeof AppDataLinesLineIdVehicleAssignmentsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_app/help': typeof AppHelpRoute
  '/_app/legal': typeof AppLegalRoute
  '/embed/$networkId': typeof EmbedNetworkIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/data/': typeof AppDataIndexRoute
  '/_app/data/networks/$networkId': typeof AppDataNetworksNetworkIdRoute
  '/_app/data/vehicles/$vehicleId': typeof AppDataVehiclesVehicleIdRoute
  '/_app/data/lines/$lineId/vehicle-assignments': typeof AppDataLinesLineIdVehicleAssignmentsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/help'
    | '/legal'
    | '/embed/$networkId'
    | '/data/'
    | '/data/networks/$networkId'
    | '/data/vehicles/$vehicleId'
    | '/data/lines/$lineId/vehicle-assignments'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/help'
    | '/legal'
    | '/embed/$networkId'
    | '/'
    | '/data'
    | '/data/networks/$networkId'
    | '/data/vehicles/$vehicleId'
    | '/data/lines/$lineId/vehicle-assignments'
  id:
    | '__root__'
    | '/_app'
    | '/_app/help'
    | '/_app/legal'
    | '/embed/$networkId'
    | '/_app/'
    | '/_app/data/'
    | '/_app/data/networks/$networkId'
    | '/_app/data/vehicles/$vehicleId'
    | '/_app/data/lines/$lineId/vehicle-assignments'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  EmbedNetworkIdRoute: typeof EmbedNetworkIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/embed/$networkId': {
      id: '/embed/$networkId'
      path: '/embed/$networkId'
      fullPath: '/embed/$networkId'
      preLoaderRoute: typeof EmbedNetworkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/legal': {
      id: '/_app/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof AppLegalRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data/': {
      id: '/_app/data/'
      path: '/data'
      fullPath: '/data/'
      preLoaderRoute: typeof AppDataIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data/vehicles/$vehicleId': {
      id: '/_app/data/vehicles/$vehicleId'
      path: '/data/vehicles/$vehicleId'
      fullPath: '/data/vehicles/$vehicleId'
      preLoaderRoute: typeof AppDataVehiclesVehicleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data/networks/$networkId': {
      id: '/_app/data/networks/$networkId'
      path: '/data/networks/$networkId'
      fullPath: '/data/networks/$networkId'
      preLoaderRoute: typeof AppDataNetworksNetworkIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data/lines/$lineId/vehicle-assignments': {
      id: '/_app/data/lines/$lineId/vehicle-assignments'
      path: '/data/lines/$lineId/vehicle-assignments'
      fullPath: '/data/lines/$lineId/vehicle-assignments'
      preLoaderRoute: typeof AppDataLinesLineIdVehicleAssignmentsRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppHelpRoute: typeof AppHelpRoute
  AppLegalRoute: typeof AppLegalRoute
  AppIndexRoute: typeof AppIndexRoute
  AppDataIndexRoute: typeof AppDataIndexRoute
  AppDataNetworksNetworkIdRoute: typeof AppDataNetworksNetworkIdRoute
  AppDataVehiclesVehicleIdRoute: typeof AppDataVehiclesVehicleIdRoute
  AppDataLinesLineIdVehicleAssignmentsRoute: typeof AppDataLinesLineIdVehicleAssignmentsRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppHelpRoute: AppHelpRoute,
  AppLegalRoute: AppLegalRoute,
  AppIndexRoute: AppIndexRoute,
  AppDataIndexRoute: AppDataIndexRoute,
  AppDataNetworksNetworkIdRoute: AppDataNetworksNetworkIdRoute,
  AppDataVehiclesVehicleIdRoute: AppDataVehiclesVehicleIdRoute,
  AppDataLinesLineIdVehicleAssignmentsRoute:
    AppDataLinesLineIdVehicleAssignmentsRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  EmbedNetworkIdRoute: EmbedNetworkIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
